import React, { useContext, useEffect, useState } from 'react'
import { apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import ReactQuill from 'react-quill'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import FormData from 'form-data'
import { useForm } from 'react-hook-form'
import OImage from 'components/reusable/OImage'
import ErrorMessage from 'components/ErrorMessage'
import noImageFound from '../../assets/images/No-image-found.jpg'

function ContactUs () {
  const { t } = useTranslation()

  const { logoutUser, user } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'contact_us') ?? {}
  const [content, setContent] = useState('')
  const [contentAr, setContentAr] = useState('')
  const [photo, setPhoto] = useState('')

  const [updateDate, setUpdateDate] = useState()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })
  const getStaticContent = async () => {
    try {
      const path = apiPath.getStaticContent
      const payload = {
        slug: 'contact-us'
      }
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        setUpdateDate(response?.updatedAt)
        setContent(response?.content)
        setContentAr(response?.contentAr)
        setValue('photo', response?.image)
        setPhoto(response?.image)
      }
    } catch (error) {
      console.error('error: ', error.message)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const updateStaticContent = async data => {
    try {
      const formData = new FormData()
      formData.append('title', 'Contact us')
      formData.append('content', content)
      formData.append('photo', data?.photo[0])
      formData.append('contentAr', contentAr)
      const path = `${apiPath.getStaticContent}?slug=contact-us`

      const result = await apiPut(path, formData)
      if (result?.status === 200) {
        notification.success(result?.data?.message)
        getStaticContent()
      }
    } catch (error) {
      console.log('error:', error.message)
    }
  }

  useEffect(() => {
    getStaticContent()
  }, [])

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <div className=' border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 '>
              <div className='col-span-2 flex flex-wrap  items-center' />
            </div>
            <div className='pl-5 pt-4 flex'>
              <label className='mb-2 block pr-1'>
                <strong>{t('UPLOAD_IMAGE')}</strong>
              </label>
              <input
                type='file'
                name='photo'
                placeholder='Photo '
                className='form-control'
                accept='image/png,image/jpeg,image/jpg'
                {...register('photo', {
                  required: 'Please select photo.',
                  onChange: event => setPhoto(event?.target?.files[0])
                })}
              />
            </div>
            <ErrorMessage message={errors?.photo?.message} />
            <div className='pl-5 pt-4 '>
              <OImage
                src={
                  typeof photo === 'object' ? URL.createObjectURL(photo) : photo
                }
                fallbackUrl={noImageFound}
              />
            </div>
            <div className='p-5 shadow-md'>
              <label className='mb-2 block'>
                <strong>{t('FAQS_CONTENT')}</strong>
              </label>
              <ReactQuill value={content} onChange={setContent} />
            </div>
            <div className='p-5 shadow-md'>
              <label className='mb-2 block'>
                <strong>{t('FAQS_CONTENT') + t('O_ARABIC')}</strong>
              </label>
              <ReactQuill value={contentAr} onChange={setContentAr} />
            </div>
          </div>
          <p style={{ marginTop: '10px', marginLeft: '10px' }}>
            {t('LAST_UPDATE')}:- {dayjs(updateDate).format('llll')}
          </p>
          <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
            <div className='flex'>
              {(manager?.add || user?.role === 'admin') && (
                <button
                  // type='submit'
                  className='bg-[#8FC150] flex my-4 text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                  onClick={handleSubmit(updateStaticContent)}
                >
                  {t('O_UPDATE')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
